import { Injectable } from "@angular/core";
import { Validators } from "@angular/forms";
import { Observable, of } from "rxjs";
import { QuestionBase } from "../../../../shared/components/dynamic-form/question-base";
import { DropdownQuestion, dropdownOptions } from "../../../../shared/components/dynamic-form/question-dropdown";
import { TextboxQuestion } from "../../../../shared/components/dynamic-form/question-textbox";
import { pattern } from "../../../../shared/constants/patterns";

export interface ICreateInternalForm {
  name: string;
  email: string;
  phone: string;
  isChannelWorks: boolean;
  enabled: boolean;
}

@Injectable()
export class CreateInternalProviderService {
  constructor() {}

  generateQuestions(options?: {
    nameValue?: string;
    emailValue?: string;
    phoneValue?: string;
    enabledValue?: boolean;
  }): Observable<QuestionBase<string | boolean>[]> {
    if (options?.enabledValue === undefined) {
      options.enabledValue = true;
    }

    const questions: QuestionBase<string | boolean>[] = [
      new TextboxQuestion({
        key: "name",
        label: "Name",
        value: options.nameValue,
        required: true,
        order: 1,
        errors: [
          {
            key: "pattern",
            validator: Validators.pattern(pattern.words),
            message: "Name is <strong>not valid</strong>",
          },
          {
            key: "minlength",
            validator: Validators.minLength(2),
            message: "Name is <strong>too short</strong>",
          },
          {
            key: "maxlength",
            validator: Validators.maxLength(255),
            message: "Name is <strong>too long</strong>",
          },
        ],
      }),

      new TextboxQuestion({
        key: "email",
        label: "Email",
        value: options.emailValue,
        required: false,
        order: 2,
        errors: [
          {
            key: "pattern",
            validator: Validators.pattern(pattern.email),
            message: "Email is <strong>not valid</strong>",
          },
          {
            key: "maxlength",
            validator: Validators.maxLength(255),
            message: "Email is <strong>too long</strong>",
          },
        ],
      }),

      new TextboxQuestion({
        key: "phone",
        label: "Phone",
        value: options.phoneValue,
        required: false,
        order: 3,
        errors: [
          {
            key: "maxlength",
            validator: Validators.maxLength(255),
            message: "Phone is <strong>too long</strong>",
          },
        ],
      }),

      new DropdownQuestion({
        key: "enabled",
        value: options.enabledValue,
        options: dropdownOptions.yesNo,
        label: "Enabled",
        required: true,
        order: 4,
      }),
    ];

    return of(questions.filter((field) => field).sort((a, b) => a.order - b.order));
  }
}
